<template>
    <v-container :class="['bg-transparent', verticalOverflow ? 'overflow-y-auto' : undefined]"
        :style="{ 'height': height + 'px', 'min-height': height + 'px', 'max-height': height + 'px', 'width': width ? width + 'px': '100%' }"
        fluid>
        <v-row wrap dense justify="center" :style="{ 'height': '100%', 'opacity': 1.0 }">
            <v-col cols="12" xs="12" sm="12" :md="width ? 12 : 9" :lg="width ? 12 : 9" :xl="width ? 12 : 9"
                class="d-flex flex-column justify-center align-center">
                <v-card elevation="12" class="mx-auto">
                    <v-img :src="showBannerImage ? require('@/assets/images/mhps-logo-1956-chevy-pickup-v2.jpg') : undefined" :height="showBannerImage ? '160px' : '135px'" cover>
                        <v-avatar variant="outlined" size="120"
                            :style="{ position: 'absolute', top: '50%', left: '75px', transform: 'translate(-50%, -50%)'}">
                            <v-img :src="require('@/assets/images/mjc-avatar.png')" :alt="resumeData.name"></v-img>
                        </v-avatar>
                    </v-img>

                    <v-card-title :class="[uniformFont ? undefined : 'sleigher-font', uniformFont ? undefined : 'pickup-color', 'mt-1', 'pt-0']">
                        {{ resumeData.name }}
                    </v-card-title>

                    <v-card-text :class="[uniformFont ? undefined : 'text-medium-emphasis', 'mt-1', 'pt-0', 'mb-0', 'pb-0']">
                        {{ resumeData.summary }}
                    </v-card-text>

                    <v-container class="mt-1 pt-0" :style="{ 'width': width ? '100%' : undefined, 'max-width': width ? '100%' : undefined }">
                        <v-row v-if="showContactInfo">
                            <v-col>
                                <v-card-text>
                                    <div class="mb-1 font-weight-bold text-uppercase">Contact</div>
                                    <ul class="ml-1">
                                        <li style="list-style-type: none; min-width: 400px;" v-for="contact in resumeData.contacts" :key="contact"><v-icon class="mr-1" :icon="contact.logo"></v-icon>{{ contact.text }}</li>
                                    </ul>
                                </v-card-text>
                            </v-col>
                        </v-row>
                        <v-row :class="mdAndUp ? undefined : 'flex-column'">
                            <v-col :cols="mdAndUp ? '4' : undefined">
                                <v-card-text>
                                    <div class="mb-1 font-weight-bold text-uppercase">Focus</div>
                                    <ul class="ml-3">
                                        <li v-for="skill in resumeData.skills" :key="skill">{{ skill }}</li>
                                    </ul>
                                </v-card-text>

                                <v-card-text>
                                    <div class="mb-1 font-weight-bold text-uppercase">Platforms</div>
                                    <v-chip v-for="platform in resumeData.platforms" :key="platform" variant="outlined"
                                        class="clickable" @click="visitExternalLink(platform.link)">
                                        <v-icon v-if="platform.logo" start :icon="platform.logo"></v-icon>
                                        <div v-if="platform.name">{{ platform.name }}</div>
                                    </v-chip>
                                </v-card-text>

                                <v-card-text>
                                    <div class="mb-1 font-weight-bold text-uppercase">Tools</div>
                                    <v-chip v-for="tool in resumeData.tools" :key="tool" variant="outlined"
                                        class="clickable" @click="visitExternalLink(tool.link)"
                                        :style="{ 'background': (tool.light ? 'white' : undefined) }"
                                        >
                                        <v-icon v-if="tool.logo" start :icon="tool.logo"></v-icon>
                                        <v-img v-if="tool.url || tool.urlDark" start
                                            :src="((!isDarkTheme && tool.urlDark) ? tool.urlDark : tool.url)"
                                            :class="(tool.name ? 'mr-2' : undefined)"
                                            :style="{ 'margin-left': -6 + 'px' }" :width="(tool.name ? 20 : 100)" max-height="20"></v-img>
                                        <div v-if="tool.name">{{ tool.name }}</div>
                                    </v-chip>
                                </v-card-text>

                                <v-card-text>
                                    <div class="mb-3 font-weight-bold text-uppercase">Education</div>
                                    <div class="ma-0 pa-0 d-flex justify-center align-center">
                                        <v-card v-for="(school, i) in resumeData.education" :key="i" elevation="12"
                                            class="ma-0 pa-0" :style="{ 'width': mdAndUp ? '285px' : '75vw' }">
                                            <div v-if="school.organization === 'Trinity College'"
                                                class="pt-4 pb-2 d-flex justify-center align-center">
                                                <TrinityLogo :height="35" :isDarkTheme="isDarkTheme" class="clickable"
                                                    @click="visitExternalLink(school.url)">
                                                </TrinityLogo>
                                            </div>
                                            <v-img class="ml-4 mt-4 mb-2 clickable" v-if="school.logo"
                                                :src="school.logo" height="50" @click="visitExternalLink(school.url)">
                                            </v-img>
                                            <div class="d-flex flex-column align-center justify-start">
                                                <v-card-text :class="[uniformFont ? undefined : 'text-medium-emphasis', 'mb-0', 'pb-0']">
                                                    {{ school.degree }}
                                                </v-card-text>
                                                <v-card-text class="white">
                                                    <ul class="ml-3">
                                                        <li v-for="(distinction, i) in school.distinctions" :key="i">{{
                                                        distinction }}</li>
                                                    </ul>
                                                </v-card-text>
                                            </div>
                                        </v-card>
                                    </div>
                                </v-card-text>
                            </v-col>
                            <v-col :cols="mdAndUp ? '8' : undefined">
                                <v-card-text>
                                    <div class="mb-1 font-weight-bold text-uppercase">Experience</div>
                                    <template v-if="experienceTimeline">
                                        <v-timeline align="start" side="end" size="small">
                                        <v-timeline-item v-for="(job, i) in resumeData.experience" :key="i" fill-dot
                                            :size="10">
                                            <!-- :dot-color="--pickup-color" :icon="item.icon" -->
                                            <template v-slot:opposite>
                                                <div :class="'pt-1 headline font-weight-bold'">
                                                    {{ job.end ? `${job.start} - ${job.end}` : `Since ${job.start}` }}
                                                </div>
                                            </template>
                                            <ExperienceItem :job="job" :uniformFont="uniformFont" :isDarkTheme="isDarkTheme"></ExperienceItem>
                                        </v-timeline-item>
                                    </v-timeline>
                                    </template>
                                    <v-container v-else class="ma-0 pa-0">
                                        <v-row class="ma-0 pa-0" v-for="(job, i) in resumeData.experience" :key="i">
                                            <v-col class="ml-0 mr-0 pl-0 pr-0">
                                                <ExperienceItem :job="job" :showDates="true" :uniformFont="uniformFont" :showURLs="true" :isDarkTheme="isDarkTheme"></ExperienceItem>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card-text>
                            </v-col>
                        </v-row>
                    </v-container>

                    <v-card-actions>

                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>

    </v-container>
</template>

<script>
import { reactive } from 'vue'
import { useDisplay } from 'vuetify'
import TrinityLogo from './logos/TrinityLogo.vue'
import ExperienceItem from './resumeItems/ExperienceItem.vue'
import { URLS } from '../utils/constants'
export default {
name: 'Resume',
props: {
    height: {
        type: Number,
        required: false,
        default: null
    },
        isDarkTheme: {
            type: Boolean,
            required: false,
            default: true
        },
        width: {
        type: Number,
        required: false,
        default: null
    },
        verticalOverflow: {
            type: Boolean,
            required: false,
            default: true
        }
        ,
        experienceTimeline: {
            type: Boolean,
            required: false,
            default: true
        },
        showBannerImage: {
            type: Boolean,
            required: false,
            default: true
        },
        showContactInfo: {
            type: Boolean,
            required: false,
            default: false
        },
        uniformFont: {
            type: Boolean,
            required: false,
            default: false
        }
},
components: {
    TrinityLogo, ExperienceItem
},
setup(props) {
    const resumeData = reactive({
        name: 'Michael Cross',
        summary: 'Backend-focused full-stack engineer with 18+ years of experience building reliable, performant infrastructure, shipping features fast, and closing revenue-critical gaps. Brings hands-on expertise in Node.js, PostgreSQL, Docker, and AWS with a track record of leading architecture and scaling decisions. Builds systems that unblock sales, support onboarding, and simplify ops, often stepping in as de facto CTO when needed. Balances delivery speed with long-term maintainability in resource-constrained environments.',
        skills: [
            'Website & Cloud Application Architecture',
            'Cloud Infrastructure / DevSecOps',
            'Native Desktop & Mobile Applications',
            'Technical Leadership',
            'Agile Development Methodologies & Tools, Process Efficiency',
            'Research, Proposals, Designs, Prototypes, Proofs of Concept',
            'Debugging, Testing, Profiling, Performance',
            'Documentation',
            'Training',
        ]
        ,
        contacts: [
            { logo: 'mdi-email', text: 'mikes.high.performance.software@gmail.com'},
            { logo: 'mdi-web', text: 'www.mhps.io' },
            { logo: 'mdi-github', text: URLS.gitHub },
            { logo: 'mdi-linkedin', text: URLS.linkedIn },
            { logo: 'mdi-stack-overflow', text: URLS.stackOverflow }
        ],
        platforms: [
            { name: 'Linux', logo: 'mdi-linux', link: 'https://rockylinux.org/' }, 
            { name: 'Amazon Web Services', logo: 'mdi-aws', link: 'https://aws.amazon.com/' },
            { name: 'Google Cloud Platform', logo: 'mdi-google-cloud', link: 'https://cloud.google.com/' },
            { name: 'DigitalOcean', logo: 'mdi-digital-ocean', link: 'https://m.do.co/c/c08342d49456' },
            { name: 'macOS', logo: 'mdi-apple', link: 'https://www.apple.com/macos' },
            { name: 'iOS', logo: 'mdi-apple', link: 'https://www.apple.com/ios' }, 
            { name: 'iPadOS', logo: 'mdi-apple', link: 'https://www.apple.com/ipados' },
        ],
        tools: [
            { name: 'Javascript', logo: 'mdi-language-javascript', link: 'https://en.wikipedia.org/wiki/JavaScript' },
            { name: 'Swift', logo: 'mdi-language-swift', link: 'https://www.swift.org/' }, 
            { name: 'Obj-C', logo: 'mdi-apple', link: 'https://developer.apple.com/library/archive/documentation/Cocoa/Conceptual/ProgrammingWithObjectiveC/Introduction/Introduction.html' },
            { name: 'C', logo: '', url: 'https://upload.wikimedia.org/wikipedia/commons/1/18/C_Programming_Language.svg', link: 'https://en.wikipedia.org/wiki/C_(programming_language)' }, 
            { name: 'Docker', logo: 'mdi-docker', link: 'https://www.docker.com/' },
            { name: 'PostgreSQL', logo: '', url: 'https://wiki.postgresql.org/images/a/a4/PostgreSQL_logo.3colors.svg', link: 'https://www.postgresql.org/' },
            { name: '', logo: '', url: require('@/assets/images/logos/arangodb-logo-light.png'), urlDark: 'https://www.arangodb.com/wp-content/uploads/2022/06/ArangoDB-dark-logo-2022.png', link: 'https://www.arangodb.com/' },
            { name: '', logo: '', url: require('@/assets/images/logos/auth0-logo-primary-light.svg'), urlDark: require('@/assets/images/logos/auth0-logo-primary-dark.svg'), link: 'https://auth0.com/'},
            { name: '', logo: '', url: require('@/assets/images/logos/openai-logo-light.svg'), urlDark: require('@/assets/images/logos/openai-logo-dark.svg'), link: 'https://openai.com/'},
            { name: 'Anthropic AI', logo: '', url: require('@/assets/images/logos/anthropic.svg'), urlDark: require('@/assets/images/logos/anthropic-dark.svg'), link: 'https://www.anthropic.com'},
            { name: 'bash', logo: 'mdi-bash', link: 'https://www.gnu.org/software/bash/' },
            { name: 'GraphQL', logo: 'mdi-graphql', link: 'https://graphql.org/' }, 
            { name: 'Git', logo: 'mdi-git', link: 'https://git-scm.com/' },
            { name: 'HTML', logo: 'mdi-language-html5', link: 'https://html.spec.whatwg.org/' }, 
            { name: 'CSS', logo: 'mdi-language-css3', link: 'https://www.w3.org/TR/CSS/#css' },
            { name: 'Node.js', logo: 'mdi-nodejs', link: 'https://nodejs.org/en/' },
            { name: 'Vue.js', logo: 'mdi-vuejs', link: 'https://vuejs.org/' },
            { name: 'React', logo: '', url: require('@/assets/images/logos/react.svg'), link: 'https://react.dev/' },
            { name: 'Vuetify', logo: 'mdi-vuetify', link: 'https://vuetifyjs.com' },
            { name: '', logo: '', url: require('@/assets/images/logos/hasura-light.svg'), urlDark: require('@/assets/images/logos/hasura-dark.svg'), link: 'https://hasura.io/' },
            { name: 'Nginx', logo: '', url: require('@/assets/images/logos/nginx.png'), link: 'https://www.nginx.com/' }, 
            { name: 'Jenkins', logo: '', url: require('@/assets/images/logos/jenkins.png'), link: 'https://www.jenkins.io/' },
            { name: 'Github', logo: 'mdi-github', link: 'https://github.com/' },
            { name: 'XCode', logo: 'mdi-apple', link: 'https://developer.apple.com/xcode/'},
            { name: 'VSCode', logo: 'mdi-microsoft-visual-studio-code', link: 'https://code.visualstudio.com/'},
            { name: 'ClickUp', logo: '', url: require('@/assets/images/logos/clickup.png'), link: 'https://clickup.com/' },
            { name: 'YouTrack', logo: '', url: require('@/assets/images/logos/youtrack.svg'), link: 'https://www.jetbrains.com/youtrack/' },
            { name: 'Jira', logo: 'mdi-jira', link: 'https://www.atlassian.com/software/jira' },
            { name: 'CloudConnexa', logo: '', url: require('@/assets/images/logos/OpenVPN-dark.svg'), urlDark: require('@/assets/images/logos/OpenVPN.svg'), link: 'https://openvpn.net/cloud-vpn/' },
            { name: '', url: require('@/assets/images/logos/cesiumjs_white.svg'), urlDark: require('@/assets/images/logos/cesiumjs_black.svg'), link: 'https://cesium.com/platform/cesiumjs/' }
        ],
        experience: [
        {
                organization: 'ChaosTrack',
                orgDescription: 'A platform for automating cybersecurity training drills that simulate real-world attacks',
                url: 'https://chaostrack.com/',
                logo: props.isDarkTheme ? require('@/assets/images/logos/CT-Logo-White-on-Trans.png') : require('@/assets/images/logos/CT-Logo-White-on-Black.png'),
                start: 'Mar. \'22',
                end: null,
                title: 'Sr. Software Engineer, Tech Lead (Contract)',
                distinctions: [
                    'Built the product\'s full backend and admin console UI from scratch, including core business logic, architecture, auth + email services, database, and CI/CD pipeline',
                    'Served as the sole technical lead in a lean, founder-led environment - making engineering decisions with limited resources',
                    'Integrated generative AI platforms (OpenAI, Anthropic AI) to automate training scenarios in support of the product vision',
                    'Developed GraphQL and REST APIs (Hasura), managed data modeling (ArangoDB), user accounts, and role-based access (Auth0)',
                    'Setup CI/CD infrastructure (GitHub Actions) and AWS deployment for secure, testable delivery',
                    'Mentored offshore contractors on design patterns, code quality, and implementation decisions',
                    'Documented system architecture, customer setup workflows to speed up onboarding and reduce technical debt; managed defect and feature tracking (ClickUp) to enable QA and release processes',
                ]
            },
            {
                organization: 'Revelstoke Security (acquired by Arctic Wolf)',
                orgDescription: 'A low-code/no-code security orchestration, automation, and response platform (SOAR)',
                url: 'https://www.revelstoke.io',
                logo: props.isDarkTheme ? require('@/assets/images/logos/arctic-wolf-and-revelstoke-light.png') : require('@/assets/images/logos/arctic-wolf-and-revelstoke-dark.png'),
                start: 'Sept. \'20',
                end: 'June \'24',
                title: 'Sr. Software Engineer / Sr. Software Engineer (Contract)',
                distinctions: [
                    'Built the platform\'s core workflow engine from scratch to support running security playbooks using a hot-pluggable third-party integration library - addressing \'vendor-lock\' issues that typically increase cost of maintenance and block deployment using other SOAR products',
                    'Designed and iterated on the workflow engine to meet performance, reliability, and integration requirements for large enterprise customers',
                    'Integrated Keycloak for secure user authentication and role-based access control to support platform\'s first enterprise contracts',
                    'Led tooling work to streamline developer environment setup and shorten on-boarding timelines across a growing team',
                    'Built third-party integrations with Snowflake, CyberArk, IMAP, and Slack that directly enabled high-value customer deals and partnership opportunities',
                    'Collaborated with product and sales teams to align feature delivery with customer needs and early-stage funding goals'
                ]
            },
            {
                organization: 'Mike\'s High Performance Software',
                orgDescription: `Personal software brand focused on building self-directed applications and tools`,
                url: 'https://www.mhps.io',
                start: 'Oct. \'11',
                end: null,
                title: 'Principal Software Engineer, Sole Proprietor',
                distinctions: [
                    'Built and launched \'trak.watch\', a 3D, photo-realistic Amtrak ride-along experience with tracking map',
                    'Built and launched \'www.itrackbro.com\', a shipped package tracking service with rich delivery progress details including a route map visualization',
                    'Built and launched \'www.essentialscaryterry.com\', an (unofficial) soundboard for a popular character from a Cartoon Network series',
                    'Built and launched \'iScoredBro\', a mobile score-keeping application with data-logging and export functionality for iOS and macOS (available in Apple\'s iOS, macOS App Stores)',
                    'Built and launched \'iTalkBro\', a voice recorder and meme generator for iOS (available in Apple\'s iOS App Store)',
                ]
            },
            {
                organization: 'Dtex Systems',
                orgDescription: 'Enterprise-scale platform for endpoint data collection, cyber-intelligence and behavioral analytics',
                url: 'https://www.dtexsystems.com',
                start: 'Feb. \'15',
                end: 'Sept. \'20',
                title: 'Sr. Software Engineer',
                distinctions: [
                    'Sole Linux endpoint sensor engineer responsible for building and evolving core data collection system for large-scale enterprise server monitoring deployments',
                    'Re-architected the Linux endpoint sensor to use eBPF, resolving a critical compliance blocker and retaining a multi-hundred-thousand-dollar enterprise client',
                    'Diagnosed and fixed macOS endpoint sensor performance limitations to meet customer requirements, helping move key enterprise client pilot program to paid contract',
                    'Delivered the architectural overhauls under tight deadlines with minimal support, balancing urgency and long-term maintainability',
                    'Collaborated with customer success and QA to deploy stable, performant software in live environments',
                    'Supported field escalations and engineering diagnostics to ensure consistent client satisfaction and platform reliability'
                ]
            },
            {
                organization: 'Ingenico Mobile Solutions',
                orgDescription: 'Provider of electronic payment solutions for businesses globally',
                url: 'https://ingenico.us/mobile-solutions',
                logo: props.isDarkTheme ? require('@/assets/images/logos/ingenico_dark.png') : require('@/assets/images/logos/ingenico_light.svg'),
                start: 'Oct. \'13',
                end: 'Feb. \'15',
                title: 'Mobile Application Developer',
                distinctions: [
                    'Maintained and enhanced a suite of iOS point-of-sale apps used across international markets',
                    'Focused on business logic, hardware integration, and white-label branding across multiple product lines',
                    'Contributed to internationalization (i18n), localization (l10n), and third-party payment terminal integrations',
                    'Assisted with QA, release engineering, and developer support for external API partners'
                ]
            },
            {
                organization: 'Savant',
                orgDescription: 'Smart automation company building solutions for premium A/V, comfort and power control',
                url: 'https://www.savant.com',
                start: 'Feb. \'06',
                end: 'Oct. \'11',
                title: 'Software Engineer',
                distinctions: [
                    'Built and maintained XML-based drivers for high-end residential and commercial automation devices',
                    'Developed integration logic and tooling for IR, RS-232, and IP-controlled systems within the company\'s proprietary platform',
                    'Delivered on-site technical support and system diagnostics for high-touch clients, gaining experience in customer collaboration and live troubleshooting',
                    'Contributed to training sessions, field enablement efforts for engineers and partner installers (CEDIA, Infocomm)'
                ]
            }
        ],
        education: [
            {
                organization: 'Trinity College',
                url: 'https://www.trincoll.edu',
                degree: 'B.S., Electrical Engineering',
                distinctions: [
                    'Graduated with Honors (3.78 GPA)',
                    'Phi Beta Kappa Honor Society',
                    'Trinity College Scholars Program',
                    'Connecticut Space Grant College Consortium Undergraduate Fellow',
                    'Phi Gamma Delta Prize in Mathematics (First Place)',
                    'Physics Book Award',
                    'Theodore R. Blakeslee II Teaching Assistant Award'
                ]
            }
        ]
    })

    // Window Size Mgmt
    const { mdAndUp, smAndUp, lgAndUp } = useDisplay()
    
    // External Links

    const visitExternalLink = (url) => {
        if (url) {
            window.open(url)
        }
    }

    return {
    resumeData,
    // Functions
    visitExternalLink,
    // Window Size Management
    smAndUp,
    mdAndUp,
    lgAndUp
    }
}
}
</script>

<style>

</style>